import dayjs, { Dayjs } from 'dayjs';
import {
  Box,
  Button,
  DialogActions,
  Grid,
  Paper,
  Tab,
  Typography
} from '@mui/material';
import { StaticDateRangePicker } from '@mui/x-date-pickers-pro';
import React, { useContext, useMemo, useState } from 'react';
import { getPropertiesBySearchForm, website } from '@/utils/helpers';
import { makeStyles } from 'tss-react/mui';
import { AppContext } from '@/utils/appContext';
import { useTranslation } from 'react-i18next';
import { DateRange, TabContext, TabList, TabPanel } from '@mui/lab';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useResponsive } from '@/hooks/use-responsive';
import { IOpenings } from '@/interfaces/huWebsite';
import { restrictionsAM } from '@/_mocks/restrictions';

export const ModalDatePicker = (props: any) => {

  const { classes } = useStyles();

  const appContext = useContext(AppContext);

  const { t } = useTranslation();

  const getOpenings = () => {
    const today = dayjs();
    const propertiesFiltered = getPropertiesBySearchForm(appContext.properties, appContext.searchForms[appContext.orderIndex]);
    return propertiesFiltered.reduce(
      (accumulator: IOpenings[], currentValue) => accumulator.concat(...currentValue.openings),
      []
    ).filter((open: any) => dayjs(open.to).isAfter(today));
  };

  const openings: any[] = useMemo(() => getOpenings(), [appContext.searchForms]);

  const [arrivalDateSelection, setArrivalDateSelection] = useState<boolean>(true);

  const isPropertyClosed = (e: any) => {
    // Controllo che la struttura selezionata sia PT
    return appContext.searchForms[appContext.orderIndex].property === 'PT' && appContext.propertySelected === 'PT' ?
      // Disabilito le date in cui la struttura e chiusa oppure il sabato se sto selezionando la data di checkin solo all'interno di un determinato range di date in cui la struttura è aperta
      !openings.find(opening => e.isBetween(opening.from, opening.to, 'days', '[]')) || (e.day() === 6 && arrivalDateSelection && e.isBetween('2025-06-07T00:00:00.000000Z', '2025-09-06T00:00:00.000000Z', 'days', '[]')) :
      // Per tutte le altre strutture disabilito le date di chiusura in base al range impostato su Statamic
      !openings.find(opening => e.isBetween(opening.from, opening.to, 'days', '[]'));
  };

  const disableSaturdayForPT = (date: Dayjs) => {
    const last = appContext.searchForms[appContext.searchForms.length - 1];
    const day = date.day();
    if (last.property === 'PT') {
      return day === 6;
    } else {
      return false;
    }
  };

  const [dateType, setDateType] = useState('1');

  const handleChangeDateType = (event: React.SyntheticEvent, newValue: string) => {
    setDateType(newValue);
  };

  const downMd = useResponsive('down', 'md');

  const setDates = (value: DateRange<Dayjs>) => {
    appContext.setUpdateSearch(true);
    appContext.searchForms[appContext.orderIndex].GuestArrival = value[0]?.format('YYYY-MM-DD') || '';
    appContext.searchForms[appContext.orderIndex].GuestDeparture = value[1]?.format('YYYY-MM-DD') || '';
    appContext.setSearchForms([...appContext.searchForms]);
  };

  const MyActionBar = () => {
    const { t } = useTranslation();
    return (
      <DialogActions>
        {
          website.code === 'VP' ? (
            <Button color={'secondary'} variant={'containedSecondaryVP'} onClick={() => {
              props.params.handleCloseModalDatePicker();
            }}>{t('Select')}</Button>
          ) : (
            <Button onClick={() => {
              props.params.handleCloseModalDatePicker();
            }}>{t('Select')}</Button>
          )
        }
      </DialogActions>
    );
  };

  return (
    <>
      <Grid
        container
        alignItems={'center'}
        justifyContent={'space-evenly'}
        direction={'row'}
        pt={3}
        pb={2}
        pr={2}
        pl={2}
        sx={{ borderBottom: '1px solid #F4F3EF', position: 'relative' }}>
        {
          (props.params.container === 'DrawerSearchWidget' || downMd) && (
            <Box sx={{ position: 'absolute', left: 0, cursor: 'pointer' }} p={3} pl={4}>
              <ArrowBackIcon onClick={() => props.params.handleCloseModalDatePicker()} />
            </Box>
          )
        }
        <Grid item xs={12} textAlign={'center'}>
          <Typography variant={'h4'} component={'h4'}>
            {t('arrival_and_departure')}
          </Typography>
        </Grid>
      </Grid>

      {/*<Box pr={4} pl={4} pt={3}>
          <Typography component={"p"} variant={"body1"}>La struttura nel periodo dal 01/06 al 01/09 ha un minimum stay di 7 notti</Typography>
      </Box>*/}

      <Box pr={4} pl={4} pt={2}>
        <Typography variant={'h5'} component={'h4'} pb={1}>
          {t('When?')}
        </Typography>

        <Box className={classes.tabDateType}>
          <TabContext value={dateType}>
            <TabList onChange={handleChangeDateType} sx={{ display: 'none' }}>
              <Tab label="Scegli le date" value="1" />
              <Tab label="Date flessibili" value="2" />
            </TabList>

            <TabPanel value="1" sx={{ padding: 0, paddingTop: 2 }}>
              <StaticDateRangePicker
                className={classes.calendar}
                displayStaticWrapperAs="mobile"
                defaultCalendarMonth={dayjs(
                  appContext.openings.find((opening: any) => dayjs(opening.from).isAfter(dayjs()))
                    ?.from
                )}
                disableAutoMonthSwitching={true}
                referenceDate={dayjs(
                  appContext.openings.find((opening: any) => dayjs(opening.from).isAfter(dayjs()))
                    ?.from
                )}
                reduceAnimations={true}
                shouldDisableDate={(e) => isPropertyClosed(e)}
                disablePast={true}
                value={[
                  dayjs(appContext.searchForms[appContext.orderIndex].GuestArrival, 'YYYY-MM-DD').isValid() ? dayjs(appContext.searchForms[appContext.orderIndex].GuestArrival, 'YYYY-MM-DD') : null,
                  dayjs(appContext.searchForms[appContext.orderIndex].GuestDeparture, 'YYYY-MM-DD').isValid() ? dayjs(appContext.searchForms[appContext.orderIndex].GuestDeparture, 'YYYY-MM-DD') : null
                ]}
                onRangePositionChange={(e) => e === 'start' ? setArrivalDateSelection(true) : setArrivalDateSelection(false)}
                onChange={(e) => setDates(e)}
                onAccept={() => {
                  props.params.handleCloseModalDatePicker();
                }}
                slots={{
                  actionBar: MyActionBar
                }}
                localeText={{ start: t('start_date_picker_placeholder'), end: t('end_date_picker_placeholder') }}
                slotProps={{
                  actionBar: {
                    // The actions will be the same between desktop and mobile
                    actions: ['accept']
                  },
                  toolbar: {
                    toolbarFormat: ''
                  }
                }}
              />
            </TabPanel>

            {/*<TabPanel value="2" sx={{padding: 0, paddingTop: 3}}>
              <Box pt={2} pb={2}>
                <hr/>

                <Typography variant={'body1'} component={'p'} pt={3} pb={2}>
                  Quanto vorresti che durasse il tuo soggiorno?
                </Typography>

                <Grid
                  container
                  direction={'row'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  pb={3}>
                  <Grid item className={classes.boxRange}>
                    <Typography component={'p'} variant={'body1'}>
                      2 o 3 giorni
                    </Typography>
                  </Grid>
                  <Grid item className={classes.boxRange}>
                    <Typography component={'p'} variant={'body1'}>
                      1 settimana
                    </Typography>
                  </Grid>
                  <Grid item className={classes.boxRange}>
                    <Typography component={'p'} variant={'body1'}>
                      2 settimane
                    </Typography>
                  </Grid>
                </Grid>

                <hr/>

                <Typography variant={'body1'} component={'p'} pt={3} pb={2}>
                  In quale mese vuoi viaggiare?
                </Typography>

                <Slider {...sliderSetting} className={classes.sliderMonth}>
                  <Box className={classes.boxMonth}>
                    <CalendarMonthIcon/>
                    <Typography component={'p'} variant={'body1'}>
                      Gennaio
                    </Typography>
                    <Typography component={'p'} variant={'body1'}>
                      2023
                    </Typography>
                  </Box>

                  <Box className={classes.boxMonth}>
                    <CalendarMonthIcon/>
                    <Typography component={'p'} variant={'body1'}>
                      Febbraio
                    </Typography>
                    <Typography component={'p'} variant={'body1'}>
                      2023
                    </Typography>
                  </Box>

                  <Box className={classes.boxMonth}>
                    <CalendarMonthIcon/>
                    <Typography component={'p'} variant={'body1'}>
                      Marzo
                    </Typography>
                    <Typography component={'p'} variant={'body1'}>
                      2023
                    </Typography>
                  </Box>

                  <Box className={classes.boxMonth}>
                    <CalendarMonthIcon/>
                    <Typography component={'p'} variant={'body1'}>
                      Aprile
                    </Typography>
                    <Typography component={'p'} variant={'body1'}>
                      2023
                    </Typography>
                  </Box>

                  <Box className={classes.boxMonth}>
                    <CalendarMonthIcon/>
                    <Typography component={'p'} variant={'body1'}>
                      Maggio
                    </Typography>
                    <Typography component={'p'} variant={'body1'}>
                      2023
                    </Typography>
                  </Box>
                </Slider>
              </Box>
            </TabPanel>*/}
          </TabContext>
        </Box>
      </Box>

      {
        downMd && (
          <Paper elevation={2} className={classes.confirmBtn}>
            <Button
              color="primary"
              variant="outlined"
              onClick={() => props.params.handleCloseModalDatePicker()}>
              {t('Conferma')}
            </Button>
          </Paper>
        )
      }
    </>
  );
};


const useStyles = makeStyles()((theme) => {
  return {
    calendar: {
      '.MuiDialogActions-root button': {
        color: '#FFF'
      },
      '.MuiPickersSlideTransition-root': {
        overflow: 'visible!important'
      },
      '.MuiPickersToolbarText-root': {
        fontSize: 16
      },
      '.MuiDateRangePickerToolbar-root': {
        padding: 0,
        '.MuiTypography-overline, .MuiPickersToolbar-penIconButton': {
          display: 'none'
        },
        '.MuiTypography-root': {
          borderBottom: '4px solid transparent',
          color: 'black',
          fontFamily: theme.typography.h6.fontFamily + '!important',
          '&.Mui-selected': {
            borderBottom: '4px solid ' + theme.palette.primary.main,
            fontFamily: theme.typography.h5.fontFamily + '!important'
          }
        }
      },
      '.MuiPickersCalendarHeader-root': {
        paddingBottom: 16,
        paddingRight: 0,
        paddingLeft: 0
      },
      '.MuiPickersCalendarHeader-label': {
        cursor: 'default!important'
      },
      '.MuiDayCalendar-header': {
        borderBottom: '1px solid ' + theme.palette.primary.main,
        '.MuiDayCalendar-weekDayLabel': {
          width: 55,
          textAlign: 'center',
          margin: 0,
          fontSize: 12,
          color: 'black'
        }
      },
      '.MuiDayCalendar-weekContainer': {
        '.MuiDateRangePickerDay-root': {
          width: 55,
          textAlign: 'center',
          margin: 0,
          '.MuiPickersDay-root': {
            fontFamily: theme.typography.h1.fontFamily,
            '&.Mui-disabled': {
              fontFamily: theme.typography.body1.fontFamily
            }
          }
        }
      },
      '.MuiDialogActions-root': {
        button: {
          color: '#FFF',
          backgroundColor: '#000',
          textTransform: 'initial',
          borderRadius: 0,
          padding: '10px 55px',
          marginBottom: 20,
          [theme.breakpoints.down('md')]: {
            display: 'none'
          }
        }
      }
    },
    confirmBtn: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      left: 0,
      padding: '20px 32px',
      boxShadow: '0 -3px 10px #00000029',
      fontFamily: theme.typography.h6.fontFamily,
      '.MuiButton-root': {
        width: '100%',
        backgroundColor: 'black',
        color: 'white',
        borderRadius: 0,
        fontSize: 20,
        border: 'none',
        '&:hover': {
          backgroundColor: 'black',
          color: 'white',
          borderColor: 'black'
        }
      }
    },
    tabDateType: {
      '.MuiTabs-root': {
        border: '1px solid #efefef',
        minHeight: '40px!important',
        '.Mui-selected': {
          color: 'black',
          zIndex: 2
        },
        '.MuiTab-root': {
          width: '50%',
          minHeight: 40,
          padding: '10px 16px',
          textTransform: 'initial',
          color: '#000',
          fontFamily: theme.typography.body1.fontFamily,
          '&.Mui-selected': {
            fontFamily: theme.typography.h1.fontFamily
          }
        },
        '.MuiTabs-scroller': {
          margin: '4px!important'
        }
      },
      '.MuiTabs-indicator': {
        height: '100%!important',
        borderRadius: 4
      },
      '.MuiTabs-flexContainer': {
        justifyContent: 'space-between'
      },
      '.MuiPickersLayout-root': {
        display: 'initial!important'
      },
      '.MuiDateRangeCalendar-monthContainer': {
        width: '100%!important'
      },
      hr: {
        borderColor: '#97ddcd',
        height: 0,
        margin: 0,
        borderStyle: 'solid'
      }
    },
    boxRange: {
      border: '1px solid #97ddcd',
      backgroundColor: 'white',
      color: 'black',
      textAlign: 'center',
      padding: '6px 12px'
    },
    sliderMonth: {
      '.slick-slide': {
        margin: 4
      }
    },
    boxMonth: {
      border: '1px solid #97ddcd',
      backgroundColor: 'white',
      color: 'black',
      textAlign: 'center',
      padding: '8px 0',
      minWidth: 'inherit!important'
    }
  };
});
